import { useState, useCallback } from 'react';
import SnackBarAlert from '../components/common/alerts/SnackBarAlert';

type AlertMessageProps = {
  message: string;
  severityType: 'error' | 'warning' | 'info' | 'success' | undefined;
};

type CustomProps =
  | {}
  | {
      autoHideDuration: number;
    };

function useSnackBarAlertMessages(customProps: CustomProps = {}) {
  const [alertMessages, setAlertMessages] = useState<AlertMessageProps[]>([]);

  const addAlertMessages = useCallback((message: AlertMessageProps) => {
    setAlertMessages((prevAlertMessages: AlertMessageProps[]) => [...prevAlertMessages, message]);
  }, []);

  const handleCloseAlertMessage = (index: number) => {
    setAlertMessages((prevMessages) => prevMessages.filter((_, i) => i !== index));
  };

  const renderSnackBarAlertComponent = () => {
    return <SnackBarAlert {...customProps} messages={alertMessages} handleCloseMessage={handleCloseAlertMessage} />;
  };

  return {
    addAlertMessages,
    renderSnackBarAlertComponent,
  };
}

export default useSnackBarAlertMessages;
